import APIClient from '@/shared/http/clients/api'

const resourceName = 'DescricaoAtividade'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetDescricaoWeb = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetDescricaoWeb/`, data, config)

const aprActivityDescriptionRepository = {
  GetDescricaoWeb
}

export default aprActivityDescriptionRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/aprActivityDescription.js